import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TournamentBox from "../Tournament/TournamentBox/TournamentBox";
import RulesPopup from "../Popup/RulesPopup";
import WinningBreakup from "../Popup/WinningPopup";
import TournamentRoundPopup from "../Popup/SelectRoundPopup";
import JoiningPopup from "../Popup/JoiningPopup";
import { routesFrontend } from "../RouterFiles/routes";

import { useNavigate } from "react-router";
import { tournamentRules, tournamentPricePointPool, tournamentRoundsById, tournamentJoin } from "../../api/tournament.api";
import Popup from "../Popup/BasePopup";
import NewUserInGameNamePopUp from "../UserInGameName/NewUserInGameName";
import Button from "../CommonFields/Button";
import TeamRegistration from "../Common/TeamRegistration";
import { useProfileDataContext } from "../ProfileContext/ProfileContext";
import { toastSuccess, toastError } from "../../Utilities/toast";
import NonPremiumMaxJoinPopup from "./NonPremiumMaxJoin";

const TournamentViaCode = ({ children, joinViaCodeTournament }) => {
    const navigate = useNavigate();
    const { fetchAccountProfile } = useProfileDataContext();
    const { t } = useTranslation();

    const gameId = localStorage.getItem("activeGameId");
    const gameName = localStorage.getItem("activeGame");

    const [list, setList] = useState([]);
    const [isSubscriptionPopup, setSubscriptionPop] = useState(false);

    const [isRulesPopup, setIsRulesPopup] = useState(false);
    const [isPricePointPoolModel, setPricePointPool] = useState(false);
    const [isJoinViaInviteCode, setisJoinViaInviteCode] = useState(false);
    const [isTournamentRound, setisTournamentRound] = useState(false);
    const [isTournamentJoiningPopup, setisTournamentJoiningPopup] = useState(false);
    const [rules, setRules] = useState("");
    const [prizePool, setPrizePool] = useState('');
    const [item, selectedItem] = useState('');
    const [code, setCode] = useState('');
    const [isPopupOpenTournament, setPopupOpenTournament] = useState(true);
    const [rounds, setRounds] = useState([]);
    const [firstRoundId, setFirstRoundId] = useState('');
    const [selectedMatchDate, setSelectedMatchDate] = useState('');
    const [inGameNamePopup, setinGameNamePopup] = useState(false);
    const [uniqueIgn, setUniqueIgn] = useState("");
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const [isTeamRegistrationForm, setIsTeamRegistrationForm] = useState(false);
    const [walletUsage, setWalletUsageData] = useState(null);
    const [coinStore, setCoinStore] = useState(false);
    const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);

    async function fetchRulesData(item) {
        try {
            let response = await tournamentRules(item);
            if (response?.success) {
                setRules(response?.item?.rules);
            }
            else {
                setRules('');
            }
            setIsRulesPopup(true)
        } catch (error) {
            setRules('');
        }
    }

    async function fetchPricePointPoolData(id, item) {
        localStorage.setItem("activeGame", item?.gameAry?.name);
        localStorage.setItem("activeGameId", item?.gameAry?._id);
        localStorage.setItem("activeGameTypeId", item?.gameTypeAry?._id);
        selectedItem(item);
        try {
            let response = await tournamentPricePointPool(id);
            if (response?.success) {
                setPrizePool(response?.data);
            }
            else {
                setPrizePool('');
            }
            setPricePointPool(true)
        } catch (error) {
            setPrizePool('');
        }
    }

    const getjoin = async (id, item) => {
        localStorage.setItem("activeGame", item?.gameAry?.name);
        localStorage.setItem("activeGameId", item?.gameAry?._id);
        localStorage.setItem("activeGameTypeId", item?.gameTypeAry?._id);
        selectedItem(item);
        getRounds(id, item);
    }

    const getRounds = async (id, item) => {
        localStorage.setItem("activeGame", item?.gameAry?.name);
        localStorage.setItem("activeGameId", item?.gameAry?._id);
        localStorage.setItem("activeGameTypeId", item?.gameTypeAry?._id);
        selectedItem(item);
        try {
            let response = await tournamentRoundsById(id);
            if (response?.success) {
                setRounds(response);
                setisTournamentRound(true)
            }
            else {
                setRounds([]);
            }
        } catch (error) {
            setRounds([]);
        }
    }

    const onJoinTournament = async () => {
        if (coinStore == false) {
            let data = {
                event: item?._id,
                contest: firstRoundId,
                currencyCode: item?.currency?.[0]?.inCurrency?._id,
                inGameUserName: uniqueIgn,
                uniqueIGN: uniqueIgn,
                user: JSON?.parse(localStorage.getItem("profile"))?.user_id
            };

            if (
                item?.gameTypeAry?.players &&
                parseInt(item?.gameTypeAry?.players) > 1
            ) {
                data.players = item?.gameTypeAry?.players
                data.extraPlayers = item?.gameTypeAry?.extraPlayers
                data.game_type = item?.gameTypeAry?._id
                data.game = item?.gameAry?._id
                localStorage.setItem("registerData", JSON.stringify(data))
                localStorage.setItem("registerType", "tournament")

                setisTournamentJoiningPopup(false);
                navigate("/team-registration")
            }
            else {
                try {
                    const res = await tournamentJoin(data);
                    if (res?.success && res?.data) {
                        fetchAccountProfile()
                        navigate(`/tournament/details/${item?._id}`)
                    } else {
                        if(res?.data?.errors[0]?.data==="events.validation.MAX_FREE_TRANSACTION"){
                            setisTournamentJoiningPopup(false);
                            setSubscriptionPop(true)
                        }else{
                            setIsDisableJoinBtn(false);
                            toastError(res?.data?.errors?.[0]?.msg);
                        }
                    }
                } catch (error) {
                    setIsDisableJoinBtn(false);
                    toastError(error);
                }
            }
        }
        else {
            let redirectUrl = routesFrontend.rewards;
            navigate(redirectUrl, { state: 1 })
            // alert("redirect to coin store")
        }
    }

    const onJoinContestClick = (contest) => {
        setIsDisableJoinBtn(false);
        setisTournamentJoiningPopup(contest);
      }

    return (
        <>
            {isPopupOpenTournament && (
                <Popup isOpen={isPopupOpenTournament} title={localStorage?.getItem('activeGame')?.toLocaleLowerCase() || "pubg"} onClose={() => setPopupOpenTournament(false)}>
                    <TournamentBox item={joinViaCodeTournament} setIsRulesPopup={fetchRulesData} setPricePointPool={fetchPricePointPoolData} getjoin={getjoin} />
                </Popup>
            )}

            {isRulesPopup && (
                <RulesPopup
                    isOpen={isRulesPopup}
                    title={t('tournament_list.rules')}
                    onClose={() => setIsRulesPopup(false)}
                    rules={rules}
                />
            )}

            {isPricePointPoolModel && (
                <WinningBreakup
                    isOpen={isPricePointPoolModel}
                    title={t('tournament_list.winning_breakup')}
                    onClose={() => setPricePointPool(false)}
                    prizePool={prizePool}
                    tournament={item}
                    contestData={item}
                    contestId={item?._id}
                    popupType={'tournament'}
                />
            )}

            {/* Round Popup */}
            {isTournamentRound && (
                <TournamentRoundPopup
                    isOpen={isTournamentRound}
                    title={item?.title}
                    onClose={() => setisTournamentRound(false)}
                    tournaments={item}
                    rounds={rounds}
                    firstRoundId={firstRoundId}
                    setFirstRoundId={setFirstRoundId}
                    setSelectedMatchDate={setSelectedMatchDate}
                    setisTournamentRound={setisTournamentRound}
                    setisTournamentJoiningPopup={onJoinContestClick}
                    setWalletUsageData={setWalletUsageData}
                    setCoinStore={setCoinStore}
                />
            )}

            {isTournamentJoiningPopup && (
                <JoiningPopup
                    isOpen={isTournamentJoiningPopup}
                    title={item?.title}
                    popupType={'tournament'}
                    onClose={() => setisTournamentJoiningPopup(false)}
                    tournaments={item}
                    selectedMatchDate={selectedMatchDate}
                    // uniqueIgn={uniqueIgn}
                    setingameName={setUniqueIgn}
                    walletUsage={walletUsage}
                    onJoinTournament={onJoinTournament}
                    isDisableJoinBtn={isDisableJoinBtn}
                    setIsDisableJoinBtn={setIsDisableJoinBtn}
                />
            )}
            {isSubscriptionPopup && (
          <NonPremiumMaxJoinPopup
          message={t('premium.you_have_already_joined_today', { title:  "tournament", total:  localStorage?.getItem('noOfTournament') })}
          isOpen={isSubscriptionPopup}
          onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
          onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }}/>
        )}
        </>
    );
};

export default TournamentViaCode;